import Badge from './Badge';

export default {
  id: 'blank_2',
  title: 'Blank_2',
  premium: true,
  colors: 1,
  BadgeComponentStateless: Badge
};
